const LoadingScreen = () => {
  return;
};

export default LoadingScreen;
